<div class="terms-popup">
  <h1>Review Terms & conditions and privacy policy</h1>

  <img src="/assets/terms.svg" />

  <p>
    Please accept our
    <a
      color="primary"
      target="_blank"
      rel="noopener"
      [attr.href]="tcUrl || null"
      (click)="preventMissingLink($event, tcUrl)"
    >
      Terms and conditions
    </a>
    and
    <a
      color="primary"
      target="_blank"
      rel="noopener"
      [attr.href]="privacyUrl || null"
      (click)="preventMissingLink($event, privacyUrl)"
    >
      Privacy policy
    </a>
    to be able to use the application.
  </p>

  <div>
    <button
      mat-flat-button
      class="accept-btn"
      color="primary"
      (click)="accept()"
      [disabled]="isAccepting"
      appTrackClick="accept-terms-btn"
      ctaType="primary"
    >
      I accept
    </button>
  </div>
</div>
